import * as fcl from "@onflow/fcl";
import MenuPageUser from "shared/bars/MenuPageUser.js";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { getUsers } from "shared/services/api-assistant.js";
import LoadingSquare from "shared/components/loading/LoadingSquare.js";

interface PageUserProps {
  yScrollPosition: number;
  props: object;
}

const PageUser: React.FC<PageUserProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { address } = useParams();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchUser = () => {
    getUsers({
      handleSuccess: (d) => {
        if (d.data.getUsers && d.data.getUsers.length > 0) {
          setUser(d.data.getUsers[0]);
        }
        setIsLoading(false);
      },
      handleError: (e) => {
        console.log(e);
        setIsLoading(false);
      },
      params: { search: address },
    });
  };

  useEffect(() => {
    if (address === "me") {
      if (!props.assistantUser?.address) {
        fcl.authenticate();
      } else {
        const pathSuffix = location.pathname.replace("/user/me", "");
        navigate(`/user/${props.assistantUser.address}${pathSuffix}${location.search}`, { replace: true });
      }
    } else {
      fetchUser();
    }
  }, [address, props.assistantUser, location.pathname]);

  if (isLoading) return <LoadingSquare />;

  return (
    <div id="PageUser" className="w-100 h-100">
      <div className="d-flex flex-column w-100 h-100">
        <div className="flex-shrink-0">
          <MenuPageUser user={user} {...props} />
        </div>

        <div className="flex-grow-1 overflow-auto">
          <Outlet context={user} />
        </div>
      </div>
    </div>
  );
};

export default PageUser;
